export default function AboutUs() {
  return (
    <section id="about-us" className="py-20 bg-white">
      <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center">
        {/* Icon Illustration */}
        <div className="flex justify-center mb-8">
          <div className="flex gap-6">
            <div className="w-16 h-16 flex items-center justify-center">
              <i className="ri-tools-line text-[#1e3a5f] text-6xl"></i>
            </div>
            <div className="w-16 h-16 flex items-center justify-center">
              <i className="ri-heart-pulse-line text-[#1e3a5f] text-6xl"></i>
            </div>
            <div className="w-16 h-16 flex items-center justify-center">
              <i className="ri-shield-check-line text-[#1e3a5f] text-6xl"></i>
            </div>
          </div>
        </div>

        {/* Section Header */}
        <p className="text-gray-500 uppercase tracking-wider text-sm font-medium mb-6">
          ABOUT OUR COMPANY
        </p>

        {/* About Content */}
        <div className="space-y-6 text-gray-700 text-lg leading-relaxed">
          <p>
            Independence Medical Equipment has been serving the tri-state area for over 15 years, providing expert repair and maintenance services for durable medical equipment. Our mission is simple: to restore and maintain your independence through reliable, professional equipment repair services.
          </p>
          <p>
            Our team of certified technicians brings decades of combined experience in servicing power wheelchairs, medical scooters, hospital beds, lift chairs, and patient lifts. We understand that your mobility equipment isn't just a device—it's your freedom, your independence, and your connection to the world around you.
          </p>
          <p>
            We pride ourselves on rapid response times, transparent pricing, and quality workmanship that stands the test of time. Whether you need a simple battery replacement or a complex motor repair, we treat every job with the same level of care and professionalism. We work with most insurance providers and Medicare to make our services accessible to everyone who needs them.
          </p>
          <p>
            At Independence Medical Equipment, we're not just fixing equipment—we're restoring independence, one repair at a time. 🛠️
          </p>
        </div>

        {/* Stats */}
        <div className="grid md:grid-cols-3 gap-8 mt-16">
          <div className="text-center">
            <p className="text-5xl font-bold text-[#14B8A6] mb-2">15+</p>
            <p className="text-gray-600 font-medium">Years of Service</p>
          </div>
          <div className="text-center">
            <p className="text-5xl font-bold text-[#14B8A6] mb-2">5000+</p>
            <p className="text-gray-600 font-medium">Repairs Completed</p>
          </div>
          <div className="text-center">
            <p className="text-5xl font-bold text-[#14B8A6] mb-2">98%</p>
            <p className="text-gray-600 font-medium">Customer Satisfaction</p>
          </div>
        </div>
      </div>
    </section>
  );
}